import React from 'react';
import AzureIcon from 'components/icons/AzureIcon';
import ZoomIcon from 'components/icons/ZoomIcon';
import TeamsIcon from 'components/icons/TeamsIcon';
import CiscoIcon from 'components/icons/CiscoIcon';
import SBCIcon from 'components/icons/SBCIcon';
import GCCHighIcon from 'components/icons/GCCHighIcon';
import UserTeamsSection from './UserTeamsSection';
import UserZoomSection from './UserZoomSection';
import UserBaseSection from './UserBaseSection';
import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import { PlatformEnums } from '@/utils/platforms';

const UserAccordion = ({
    platformUser,
    errors,
    touched,
    value,
    submitData,
    setSubmitData,
    onMoveUp,
    onMoveDown,
    platformIndex,
    platformNumbersLength,
    // TODO: Commenting out unklink button for US
    // unlinkButton,
    // primaryUser,
}) => {
    const platforms = {
        [PlatformEnums.AZURE]: {
            name: 'Azure Communication Services',
            key: 'azure',
            icon: AzureIcon,
            fields: (props) =>
                UserBaseSection({
                    submitData: submitData,
                    setSubmitData: setSubmitData,
                    errors: errors,
                    touched: touched,
                    platformUser: platformUser,
                    section: 'azure',
                    ...props,
                }),
            disabled: true,
        },
        [PlatformEnums.WEBEX]: {
            name: 'WebEx Calling',
            key: 'webex',
            icon: CiscoIcon,
            fields: (props) =>
                UserBaseSection({
                    submitData: submitData,
                    setSubmitData: setSubmitData,
                    errors: errors,
                    touched: touched,
                    platformUser: platformUser,
                    section: 'webex',
                    ...props,
                }),
            disabled: true,
        },
        [PlatformEnums.ZOOM]: {
            name: 'Zoom',
            key: 'zoom',
            icon: ZoomIcon,
            fields: (props) =>
                UserZoomSection({
                    submitData: submitData,
                    setSubmitData: setSubmitData,
                    errors: errors,
                    touched: touched,
                    platformUser: platformUser,
                    ...props,
                }),
            disabled: false,
        },
        [PlatformEnums.SBC]: {
            name: 'SBCaaS',
            key: 'SBCaaS',
            icon: SBCIcon,
            fields: (props) =>
                UserBaseSection({
                    submitData: submitData,
                    setSubmitData: setSubmitData,
                    errors: errors,
                    touched: touched,
                    platformUser: platformUser,
                    section: 'sbcaas',
                    ...props,
                }),
            disabled: true,
        },
        [PlatformEnums.TEAMS]: {
            name: 'Microsoft Teams',
            key: 'teams',
            icon: TeamsIcon,
            disabled: false,
            fields: (props) =>
                UserTeamsSection({
                    key: 'teams',
                    submitData: submitData,
                    setSubmitData: setSubmitData,
                    errors: errors,
                    touched: touched,
                    platformID: platformUser?.platformID,
                    platformUser: platformUser,
                    platformIndex: platformIndex,
                    ...props,
                }),
        },
        [PlatformEnums.GCC]: {
            name: 'GCCH',
            key: 'gcch',
            icon: GCCHighIcon,
            disabled: false,
            fields: (props) =>
                UserTeamsSection({
                    key: 'gcch',
                    section: 'gcch',
                    submitData: submitData,
                    setSubmitData: setSubmitData,
                    errors: errors,
                    touched: touched,
                    platformID: platformUser?.platformID,
                    platformUser: platformUser,
                    platformIndex: platformIndex,
                    ...props,
                }),
        },
    };

    const currentPlatform = platforms[platformUser?.platformID];
    // const accordionAdornment =
    return (
        <AccordionItemHandler
            index={platformUser?.platformID}
            key={`${currentPlatform?.key}-${platformIndex}`}
            icon={currentPlatform?.icon}
            label={currentPlatform?.name}
            errors={errors}
            touched={touched}
            values={value}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            platformIndex={platformIndex}
            noOrder={platformNumbersLength === 1}
            platformsLength={platformNumbersLength}
            // accordionAdornment={accordionAdornment}
        >
            {React.Children.map(currentPlatform?.fields?.(), (child, index) =>
                React.cloneElement(child, {
                    key: `${currentPlatform?.key}-field-${index}`,
                }),
            )}
        </AccordionItemHandler>
    );
};

export default UserAccordion;
